<template>
  <div class="loginCode">
    <img src="../../assets/loadingCode.gif" alt="">
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {};
  },
  created() {
    this.$store.commit('vuexAllPark',false)
    if (this.$route.query.code) {
      let code = this.$route.query.code;
      if (this.$route.query.from) {
        let from = this.$route.query.from;
        console.log("from", from);
        if (from == "seller") {
          window.location.href = `https://seller.zengcaicloud.com/#/loginIndex?code=${code}`
        }else if(from == "buyer"){
          window.location.href = `https://buyer.zengcaicloud.com/#/loginIndex?code=${code}`
        }else if(from == "designer"){
          window.location.href = `https://designer.zengcaicloud.com/#/loginIndex?code=${code}`
        }else if(from == "review"){
          window.location.href = `https://review.zengcaicloud.com/#/login?code=${code}`
        }
      } else {
        this.$router.replace({
          name: "login",
          query: {
            code: code,
          },
        });
      }
    }
  },
};
</script>
<style scoped lang="less">
.loginCode {
  text-align: center;
  img {
    width: 20%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/registeredLogin/LoginCode.vue